import { Box, Flex, HStack, Text } from "@chakra-ui/react";
import { MdOutlineAttachMoney } from "react-icons/md";
import { useConditionalBackground } from "@/contexts/useConditionalBackground";
import { useState } from "react";
import ConciliationTab from "@/components/ConciliationTab";
import CommissionTab from "@/components/CommissionTab";
import TaxNoteTab from "@/components/taxNote";

type TabValue = "comissão" | "conciliação" | "kam" | "taxNote";

interface Tab {
  label: string;
  value: TabValue;
}

export default function Finances() {
  const backgroundStyle = useConditionalBackground();
  const [activeTab, setActiveTab] = useState<TabValue>("comissão");

  const tabs: Tab[] = [
    { label: "COMISSÃO", value: "comissão" },
    { label: "CONCILIAÇÃO", value: "conciliação" },
    { label: "NFs", value: "taxNote" },
  ];

  return (
    <Box w="100%" py={{ base: 4, md: 4 }} transition="all 0.3s" overflowX="hidden">
      <Box
        w="100%"
        maxW="100%"
        minW="0"
        mx="auto"
        px={{ base: 4, md: 6 }}
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        gap={2}
      >
        {/* HEADER / TABS */}
        <Box
          {...backgroundStyle}
          borderRadius="xl"
          p={{ base: "2", md: "4" }}
          color="white"
          boxShadow="lg"
          width="100%"
          minW="0"
        >
          <Box
            display="flex"
            flexDirection={{ base: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ base: "flex-start", md: "center" }}
            gap={6}
          >
            <Flex alignItems="center">
              <MdOutlineAttachMoney size="2.5rem" />
              <Text
                fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                fontWeight="bold"
                ml={2}
                fontFamily="Lexend Deca"
                letterSpacing="tight"
              >
                Financeiro
              </Text>
            </Flex>

            <HStack
              spacing={{ base: 4, md: 8 }}
              justifyContent={{ base: "center", md: "flex-end" }}
              flexWrap="wrap"
              flex={1}
            >
              {tabs.map((tab: Tab) => (
                <Box
                  key={tab.value}
                  textAlign="center"
                  position="relative"
                  cursor="pointer"
                  onClick={() => setActiveTab(tab.value)}
                  px={2}
                  py={1}
                >
                  <Text
                    fontSize={{ base: "md", md: "lg", lg: "xl" }}
                    fontWeight="bold"
                    color={activeTab === tab.value ? "white" : "whiteAlpha.700"}
                    _hover={{ color: "white" }}
                    transition="all 0.2s ease"
                    fontFamily="Lexend Deca"
                    textTransform="uppercase"
                  >
                    {tab.label}
                  </Text>
                  {activeTab === tab.value && (
                    <Box
                      position="absolute"
                      bottom="-8px"
                      left="50%"
                      transform="translateX(-50%)"
                      height="4px"
                      width="full"
                      maxW="30px"
                      borderRadius="full"
                      bgColor="white"
                      transition="width 0.3s ease"
                    />
                  )}
                </Box>
              ))}
            </HStack>
          </Box>
        </Box>

        {/* CONTENT */}
        <Box w="100%" minW="0" animation="fadeIn 0.5s ease-in-out">
          {activeTab === "comissão" && (
            <CommissionTab backgroundStyle={backgroundStyle} />
          )}
          {activeTab === "conciliação" && (
            <ConciliationTab backgroundStyle={backgroundStyle} />
          )}
          {activeTab === "taxNote" && (
            <TaxNoteTab backgroundStyle={backgroundStyle} />
          )}
        </Box>
      </Box>
    </Box>
  );
}
